import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import AppContext from '../context/appContext'

const slugify = (value = '') => value
  .toString()
  .toLowerCase()
  .trim()
  .replace(/[_\s]+/g, '-')
  .replace(/[^a-z0-9-]/g, '')
  .replace(/-+/g, '-')

const cloudinaryImageUrl = (image, width) => {
  const height = Math.round(width * 0.75)

  return `https://res.cloudinary.com/l7pafu4a/image/fetch/f_webp/q_60/w_${width}/h_${height}/c_fill/${image}`
}

const AppDevelopmentBlogs = ({
  eyebrow = 'LEARN MORE',
  heading = 'About Our App Development Company',
  buttonLabel = 'View All Blogs',
  filterByApp = true,
  latestFirst = false
}) => {
  const { posts, fetchPosts } = useContext(AppContext)
  const [blogsLoading, setBlogsLoading] = useState(true)

  useEffect(() => {
    let active = true

    const loadPosts = async () => {
      try {
        setBlogsLoading(true)
        await fetchPosts()
      } finally {
        if (active) setBlogsLoading(false)
      }
    }

    loadPosts()
    return () => { active = false }
  }, [fetchPosts])

  const appBlogs = useMemo(
    () => {
      const filteredPosts = filterByApp
        ? (posts || []).filter((post) => /app/i.test(post.title || ''))
        : (posts || [])

      return (latestFirst
        ? [...filteredPosts].sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0))
        : filteredPosts
      ).slice(0, 3)
    },
    [filterByApp, latestFirst, posts]
  )

  if (!blogsLoading && appBlogs.length === 0) return null

  return (
    <section className="container py-5">
      {/* <h2 className="h5 fw-bold" style={{}}>
        {eyebrow}
      </h2> */}
      <h2 className="text-white text-center display-5 fw-bold mb-4">{heading}</h2>

      {blogsLoading ? (
        <div className="d-flex justify-content-center py-5">
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading app development articles...</span>
          </div>
        </div>
      ) : (
        <div className="row">
          {appBlogs.map((post) => {
            const slug = post.slug?.length ? post.slug : slugify(post.metaTitle || post.title || '')
            const postDate = new Date(post.date || Date.now())

            return (
              <div key={post._id || slug} className="col-sm-6 col-lg-4 col-12 my-2">
                <Link
                  onClick={() => window.scrollTo({ behavior: 'smooth', top: 0, left: 0 })}
                  to={`/blog/${slug}/`}
                  className="text-decoration-none"
                >
                  <article
                    className="card text-light rounded-4 h-100 overflow-hidden"
                    style={{ borderColor: 'rgb(101, 101, 255)', backgroundColor: 'rgba(0, 0, 0, 0)' }}
                  >
                    {post.image && (
                      <img
                        src={cloudinaryImageUrl(post.image, 720)}
                        srcSet={[
                          `${cloudinaryImageUrl(post.image, 360)} 360w`,
                          `${cloudinaryImageUrl(post.image, 540)} 540w`,
                          `${cloudinaryImageUrl(post.image, 720)} 720w`
                        ].join(', ')}
                        sizes="(max-width: 767px) calc(100vw - 24px), (max-width: 1199px) calc(50vw - 24px), calc(33vw - 24px)"
                    
                        className="card-img-top"
                        alt=""
                        loading="lazy"
                      />
                    )}
                    <div className="card-body justify-content-end d-flex flex-column text-start">
                      <p className="card-title text-light text-opacity-75 h6">{post.category || 'General'}</p>
                      <h3 className="card-title h5">{post.title || 'Untitled Post'}</h3>
                      <p className="card-text">{postDate.toLocaleString()}</p>
                    </div>
                    <div style={{ borderTopColor: 'rgb(101, 101, 255)' }} className="card-footer">
                      <div className="d-flex align-items-center">
                        <i className="fa fa-user fa-2x" aria-hidden="true"></i>
                        <div className="d-flex flex-column px-3">
                          <span className="text-light text-start">Metatech Official</span>
                          <span className="text-light text-opacity-75 text-start">{postDate.toDateString()}</span>
                        </div>
                      </div>
                    </div>
                  </article>
                </Link>
              </div>
            )
          })}
        </div>
      )}

      <div className="text-center mt-4">
        <Link
          to="/blogs"
          onClick={() => window.scrollTo({ behavior: 'smooth', top: 0, left: 0 })}
          className="btn btn-outline-light rounded-4 px-4 py-2"
        >
          {buttonLabel}
        </Link>
      </div>
    </section>
  )
}

export default AppDevelopmentBlogs
